export default __webpack_public_path__ + "assets/ms-icon-150x150.e76badd26049efba1af8175df91c788d.png";